import { render, staticRenderFns } from "./FormElementPublish.vue?vue&type=template&id=5e87bcc9&scoped=true&"
import script from "./FormElementPublish.vue?vue&type=script&lang=ts&"
export * from "./FormElementPublish.vue?vue&type=script&lang=ts&"
import style0 from "./FormElementPublish.vue?vue&type=style&index=0&id=5e87bcc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e87bcc9",
  null
  
)

export default component.exports